module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Hellikon_AG-29f86a71e37fbafac019da62859f03b0.svg";